import { useEffect, useState } from 'react'
import { useFullscreenAnnouncement } from '../../hooks/announcements/useFullscreenAnnouncement'
import {
  useHasEngagement,
  useRecordEngagement,
  useUserEngagements,
} from '../../hooks/engagement/useUserEngagements'
import { useGate } from '../../hooks/gate/useGates'
import FullscreenVideoOverlay from '../../ui/primitives/FullscreenVideoOverlay'

type VideoDecision = 'pending' | 'show' | 'hide'

interface GateVideoProps {
  gateId: string
  replayNonce?: number
}

export default function GateVideo({ gateId, replayNonce = 0 }: GateVideoProps) {
  const announcement = useFullscreenAnnouncement()
  const { data: gate, isLoading: gateRowLoading } = useGate(gateId)
  const engagements = useUserEngagements()
  const seen = useHasEngagement('gate', gate?.id)
  const { mutate: recordEngagement } = useRecordEngagement()
  const [activeReplay, setActiveReplay] = useState(0)

  useEffect(() => {
    if (replayNonce > 0) setActiveReplay(replayNonce)
  }, [replayNonce])

  const hasVideo = Boolean(gate?.videoUrl)

  let decision: VideoDecision = 'pending'
  if (!announcement.pending && !gateRowLoading && engagements.isSuccess) {
    const firstPlay = !announcement.active && !seen && hasVideo
    const replayPlay = activeReplay > 0 && hasVideo && !announcement.active
    decision = firstPlay || replayPlay ? 'show' : 'hide'
  }

  function dismiss() {
    if (gate && !seen) {
      recordEngagement({ subjectType: 'gate', subjectID: gate.id })
    }
    setActiveReplay(0)
  }

  return (
    <>
      <span data-testid="gate-video-state" data-state={decision} hidden />
      {decision === 'show' && gate?.videoUrl && (
        <FullscreenVideoOverlay
          testId="gate-video"
          videoUrl={gate.videoUrl}
          dismissible
          onClose={dismiss}
        />
      )}
    </>
  )
}
